import React from 'react'

import { AppUsersAutocomplete } from "@components/Autocomplete"
import { companyUsers } from "@signals"


export default function AppCommonFiltersUsersAutocomplete({ ...props }) {

	return <AppUsersAutocomplete
		multiple
		value={companyUsers.value}
		onChange={e => companyUsers.value = e.target.value}
		{...props}
	/>
}